import Decimal from 'break_infinity.js';

/**
 * The numeric spine. Every in-game quantity is a Decimal (TECHNICAL_APPROACH §7).
 * This module is the single place that constructs and serializes them, so the
 * rest of the core never imports break_infinity directly.
 */
export type { Decimal };
export type DecimalSource = Decimal | number | string;

export const D = (v: DecimalSource = 0): Decimal => new Decimal(v);

export const ZERO: Decimal = D(0);
export const ONE: Decimal = D(1);

/** Decimals serialize as strings so saves stay exact and JSON-safe. */
export const toStr = (d: Decimal): string => d.toString();
export const fromStr = (s: string): Decimal => new Decimal(s);

export const add = (a: Decimal, b: DecimalSource): Decimal => a.add(b);
export const sub = (a: Decimal, b: DecimalSource): Decimal => a.sub(b);
export const mul = (a: Decimal, b: DecimalSource): Decimal => a.mul(b);
export const div = (a: Decimal, b: DecimalSource): Decimal => a.div(b);
export const pow = (a: Decimal, b: DecimalSource): Decimal => a.pow(typeof b === 'string' ? new Decimal(b) : b);

export const gte = (a: Decimal, b: DecimalSource): boolean => a.gte(b);
export const gt = (a: Decimal, b: DecimalSource): boolean => a.gt(b);
export const lte = (a: Decimal, b: DecimalSource): boolean => a.lte(b);
export const lt = (a: Decimal, b: DecimalSource): boolean => a.lt(b);
export const max = (a: Decimal, b: DecimalSource): Decimal => a.max(b);
export const min = (a: Decimal, b: DecimalSource): Decimal => a.min(b);
export const floor = (a: Decimal): Decimal => a.floor();

export const isFinite = (d: Decimal): boolean => Number.isFinite(d.mantissa) && Number.isFinite(d.exponent);
